import PropTypes from 'prop-types';
import styled from 'styled-components';
const UIWellHelpText = styled.div.withConfig({
  displayName: "UIWellHelpText",
  componentId: "fy499w-0"
})(["font-size:14px;"]);
UIWellHelpText.propTypes = {
  children: PropTypes.node
};
UIWellHelpText.displayName = 'UIWellHelpText';
export default UIWellHelpText;